<template>
  <div class="slider-container">
    <div class="slider-wrapper" :style="styleobj" @touchmove="swipeMove" @touchstart="swipeStart" @touchend="swipeEnd" @mousedown="swipeStart" @mouseup="swipeEnd" @mousemove="swipeMove">
      <div class="slider-item" v-for="list in pages">
        <a :href="item.href" :class="list.length == 1 ? 'single' : ''" v-for="item in list">
          <h4>{{ item.title }}</h4>
          <p>
            <span class="star" :class="'star-' + item.star" v-if="item.objectType == 1 || item.objectType == 3"></span>
            <span class="price">{{ item.price ? item.price : '' }}</span>
            <span v-if="item.objectType == 2 || item.objectType == 7">{{ item.labelFirst }}</span>            
            <span v-if="item.showType == 2 || item.showType == 5 || item.showType == 3">{{ item.labelSecond }}</span>
          </p>
        </a>
      </div>
    </div>
    <div class="slider-pagination" v-if="pagenums > 1">
      <template v-for="n in pagenums">
        <span @click="slide(n-1)" :class="n-1 === sliderinit.currentPage? 'on':''"></span>
      </template>
    </div>
  </div>
</template>

<script>
import detectPrefixes from '../utils/detect-prefixes.js'
export default {
  props: ['sliderinit', 'pages', 'appName'],
  data() {
    return {
      basicdata: {
        poswidth: '0',
        posheight: '0',
        start: {},
        end: {},
        tracking: false,
        animation: false,
        containerClass: {
          'swiper-container-vertical': false
        },
        setIntervalid: '',
        prefixes: detectPrefixes(),
        transitionEnding: false
      }
    }
  },
  computed: {
    styleobj() {
      let style = {}
      style['transform'] = 'translate3D(' + this.basicdata.poswidth + ', 0, 0)'
      style[this.basicdata.prefixes.transition + 'TimingFunction'] = 'ease'
      style[this.basicdata.prefixes.transition + 'Duration'] = (this.basicdata.animation ? this.sliderinit.slideSpeed || 300 : 0) + 'ms'
      return style
    },
    // pagenum滑动数
    pagenums: function () {
      return this.pages.length
    },
    // 组件的核心，计算当前父级需要进行的偏移,每次要遍历节点
    currentWidth: {
      get: function () {
        let $slider
        let lastPage = this.sliderinit.currentPage

        // 获取slideritem子集
        for (let item in this.$el.children) {
          if (/slider-wrapper/ig.test(this.$el.children[item].className)) {
            $slider = this.$el.children[item]
          }
        }
        // 遍历子集
        let $sliderChildren = $slider.children
        let offsetLeft = $sliderChildren[lastPage].offsetLeft
        return offsetLeft
      },
      set: function (value) {
        return value
      }
    }
  },
  methods: {
    swipeStart (e) {
      let that = this
      if (this.basicdata.transitionEnding) {
        return
      }
      this.basicdata.animation = false
      // 阻止页面滚动
      document.addEventListener('touchmove', that.preventDefault(e))
      if (e.type === 'touchstart') {
        if (e.touches.length > 1) {
          this.basicdata.tracking = false
          return
        } else {
          this.basicdata.tracking = true
          /* Hack - would normally use e.timeStamp but it's whack in Fx/Android */
          this.basicdata.start.t = new Date().getTime()
          this.basicdata.start.x = e.targetTouches[0].clientX
          this.basicdata.start.y = e.targetTouches[0].clientY
          this.basicdata.end.x = e.targetTouches[0].clientX
          this.basicdata.end.y = e.targetTouches[0].clientY
        }
      } else {
        this.basicdata.tracking = true
        /* Hack - would normally use e.timeStamp but it's whack in Fx/Android */
        this.basicdata.start.t = new Date().getTime()
        this.basicdata.start.x = e.clientX
        this.basicdata.start.y = e.clientY
        this.basicdata.end.x = e.clientX
        this.basicdata.end.y = e.clientY
      }
    },
    swipeMove (e) {
      if (this.basicdata.tracking) {
        if (e.type === 'touchmove') {
          e.preventDefault()
          this.basicdata.end.x = e.targetTouches[0].clientX
          this.basicdata.end.y = e.targetTouches[0].clientY
        } else {
          e.preventDefault()
          this.basicdata.end.x = e.clientX
          this.basicdata.end.y = e.clientY
        }
        this.basicdata.poswidth = -(this.currentWidth) + this.basicdata.end.x - this.basicdata.start.x + 'px'
      }
    },
    swipeEnd (e) {
      this.basicdata.tracking = false
      let now = new Date().getTime()
      let deltaTime = now - this.basicdata.start.t
      let deltaX = this.basicdata.end.x - this.basicdata.start.x
      let deltaY = this.basicdata.end.y - this.basicdata.start.y

      // 解除阻止
      document.removeEventListener('touchmove', this.preventDefault(e))
      /* work out what the movement was */
      if (deltaTime > this.sliderinit.thresholdTime) {
        this.slide(this.sliderinit.currentPage)
        /* gesture too slow */
        return
      } else {
        if ((deltaX > this.sliderinit.thresholdDistance) && (Math.abs(deltaY) < this.sliderinit.thresholdDistance)) {
          // swipe right
          this.pre()
          return
        } else if ((-deltaX > this.sliderinit.thresholdDistance) && (Math.abs(deltaY) < this.sliderinit.thresholdDistance)) {
          // swipe left
          this.next()
          return
        } else {
          this.slide(this.sliderinit.currentPage)
          return
        }
      }
    },
    pre () {
      if (this.sliderinit.currentPage >= 1) {
        this.sliderinit.currentPage -= 1
        this.slide()
      } else {
        this.slide()
      }
    },
    next () {
      if (this.sliderinit.currentPage < this.pagenums - 1) {
        this.sliderinit.currentPage += 1
        this.slide()
      } else {
        this.slide()
      }
    },
    slide (pagenum, type) {
      let that = this
      // 执行动画
      that.basicdata.animation = true
      // 无样式滚动
      if (type === 'animationnone') {
        that.basicdata.animation = false
      }
      if (pagenum || pagenum === 0) {
        that.sliderinit.currentPage = pagenum
      }
      that.basicdata.poswidth = -that.currentWidth + 'px'
      // 广播事件
      if (that.sliderinit.currentPage < 0 || that.sliderinit.currentPage >= that.pagenums) {
        return
      }
      that.$emit('slide', that.sliderinit.currentPage)
    },
    // 阻止页面滚动
    preventDefault (e) {
      // e.preventDefault()
    }
  }

}
</script>

<style lang="less">
@import '../assets/styles/common/_util.less';
@import '../assets/styles/common/fs';

.slider-container {
  position: relative;
  z-index: 1;
  // .fs-size(625,150);
  .fs-width(625);
  margin: 0 auto;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
}

.slider-wrapper {
  box-sizing: content-box;
//   display: flex;
  .flexbox();
  .fs-width(625);
  position: relative;
  transition-property: transform;
  width: 100%;
  z-index: 1;
  div {
    .fs-width(625);
    text-align: center;
  }
  a {
    .inline-block;
    .fs-margin(@left: 6, @right: 6);
    .fs-size(260, 74);
    .fs-padding(15, 20, 15, 20);
    background-color: #fff;
    .fs-radius(4);
    color: #333;
    text-align: left;
    &.single {
      // .fs-width(430);
    }
    h4 {
      .fs-margin(@bottom: 10);
      .fs-line-height(30);
      font-weight: normal;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    p {
      position: relative;
      overflow: hidden;
    }
    span {
      color: #999;
      .fs(24);
      -webkit-font-smoothing: antialiased;
      &.price {
        position: absolute;
        .fs-line-height(26);
        .fs-bottom(0);
        .fs-right(0);
      }
    }
  }
}

.slider-pagination {
  // position: absolute;
  // .fs-bottom(2);
  // left: 0;
  // right: 0;
  text-align: center;
  .fs-height(46);
  .fs-line-height(60);
  span {
    .inline-block;
    .fs-size(14, 14);
    .fs-margin(@left: 10, @right: 10);
    background-color: #ccc;
    .fs-radius(14);
    &.on {
      background-color: #f5734b;
    }
  }
}
</style>




// WEBPACK FOOTER //
// slide.vue?1fd69118